import React, { useState, useEffect } from "react";
import {
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import {
  TableHeader,
  IconButtonDatatable,
  DatatablesFooterServerSide,
  Loading,
  TableCellDefault,
} from "App/Component/ui";
import { headCells, STYLE_DEPARTEMEN, getRootDepartemen } from "./helpers";
import { SelectIcon } from "App/Assets";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  defaultToastError,
} from "App/utils/helpers";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";

export default function TabelRootDepartemen() {
  const classes = STYLE_DEPARTEMEN();
  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []);

  const setNewData = async (
  ) => {
    setLoading(true);

    const res = await getRootDepartemen();
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  return (
    <div className={classes.root}>
      <div className="mt-2">
        <Paper className={classes.paper}>

          <Loading show={loading} />
          <TableRootDepartemen
            rows={rows}
            classes={classes}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </div>
  );
}

export const TableRootDepartemen = ({
  rows,
  classes,
  isSelect = false,
  handleClickSelect,
  maxHeight = "auto",
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
  });

  return (
    <TableContainer
      className="custom-scrollbar"
      style={{
        maxHeight: maxHeight,
      }}
    >
      <Table
        className={classes.table}
        aria-labelledby="tableTitle"
        size={"medium"}
        aria-label="enhanced table"
      >
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCells}
        />
        <TableBody>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>

                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                      <IconButtonDatatable
                        color="secondary"
                        aria-label="delete"
                        onClick={() => handleClickSelect(row)}
                        style={{
                          background: "#D8D8D8",
                          padding: "4px",
                        }}
                      >
                        <SelectIcon width={"14"} height={"14"} fill={"#fff"} />
                      </IconButtonDatatable>
                </TableCell>
                <TableCell align="left">{row?.kode}</TableCell>
                <TableCell align="left">{row?.nama}</TableCell>
                <TableCellDefault row={row} type="custom" />
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align="center" colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
